import { createFileRoute } from '@tanstack/react-router';
import { UsersPage } from '@/features/users/UsersPage';

interface UsersSearchParams {
  page?: number;
  pageSize?: number;
  search?: string;
  sortBy?: string;
  sortOrder?: 'asc' | 'desc';
}

export const Route = createFileRoute('/_app/users')({
  component: UsersPage,
  validateSearch: (search: Record<string, unknown>): UsersSearchParams => {
    return {
      page: search.page ? Number(search.page) : undefined,
      pageSize: search.pageSize ? Number(search.pageSize) : undefined,
      search: search.search as string | undefined,
      sortBy: search.sortBy as string | undefined,
      sortOrder: search.sortOrder as 'asc' | 'desc' | undefined,
    };
  },
});
